<style scoped>
.slider-label {
  position: relative;
  top: 50%;
  transform: translate(0%, -50%);
}
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}
/* Hide default HTML checkbox */
.switch input {
  display: none;
}
/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}
.slider.disabled {
  cursor: not-allowed;
}
.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
}
input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}
input.default:checked + .slider {
  background-color: #444;
}
input.primary:checked + .slider {
  background-color: #2196f3;
}
input.success:checked + .slider {
  background-color: #8bc34a;
}
input.info:checked + .slider {
  background-color: #3de0f5;
}
input.warning:checked + .slider {
  background-color: #ffc107;
}
input.danger:checked + .slider {
  background-color: #f44336;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>

<template>
  <td>
    <div class="row p-0 m-0">
      <div class="col-3 p-0 m-0">
        <label class="switch p-0 m-0">
          <input
            type="checkbox"
            class="success"
            :disabled="disabled"
            @click="toggle()"
            :checked="content"
          />
          <span :class="{ disabled: disabled }" class="slider round"></span>
        </label>
      </div>
    </div>
  </td>
</template>

<script lang="babel">
import { bus } from "@/bus";

export default {
  props: ['content', 'model', 'attribute', 'disabled'],
  methods: {
    toggle() {
      // detect asa model
      if (
        this.model.hasOwnProperty('active') &&
        this.model.hasOwnProperty('duration') &&
        this.model.hasOwnProperty('tolerance')
      ) {
        bus.$emit("asa-active-switched");
      }

      if (this.model[this.attribute.url] !== undefined && !this.disabled) {
        return this.$http.post(this.model[this.attribute.url]).then(() => {
          this.$emit("table-update");
        });
      }
    },
  }
};
</script>
